import { useEffect } from "react";
import {
  CloseIcon,
  ErrorIcon,
  SuccessIcon,
} from "../../ui-components/global-svg-components";
import styles from "./style.module.scss";
import { clearMessage } from "../../zustand-store/toastMessages-store/actions";

export const ToastMessage = ({ message, status }) => {
  const handleToast = () => {
    clearMessage();
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      clearMessage();
    }, 10000);
    return () => {
      clearTimeout(timeout);
    };
  }, [message]);
  return (
    <>
      {message?.length && (
        <section className={styles.notificationShow}>
          <div className={styles.notification}>
            <div className={styles.notificationHeader}>
              <div className={styles.title}>
                <span className={styles.image}>
                  {status ? <SuccessIcon /> : <ErrorIcon />}
                </span>
                <p className={styles.message}>{message}</p>
              </div>
              <CloseIcon
                width="25"
                height="25"
                fillColor={status ? "#02BF90" : "#B11313"}
                handleClick={() => handleToast()}
                customClass={styles.closeIcon}
              />
            </div>
          </div>
        </section>
      )}
    </>
  );
};
